export const moduleSlug = "ENTITY_BY_TYPE";

export const FiltersFieldsTypes = {
    storage: "storage",
    users: "users",
    status: "status",
    statusType: "statusType",
    source: "source",
    branch: "branch",
    brand: "brand",
    receiver: "receiver",
    countries: "countries",
    siteGroups: "siteGroups",
    roles: "roles",
    tenants: "tenants",
    userAgentName: "userAgentName",
    responseProvider: "responseProvider",
    templateSelectorType: "templateSelectorType",
    templateSelectorCondition: "templateSelectorCondition",
    templateSelectorSource: "templateSelectorSource",
    blockSelectorSource: "blockSelectorSource",
    blockSelectorType: "blockSelectorType",
    dataSelectorAction: "dataSelectorAction",
    templateScreenshotAction: "templateScreenshotAction",
    dataSelectorType: "dataSelectorType",
    dataSelectorConditionType: "dataSelectorConditionType",
    normalizer: "normalizer",
    retryRuleType: "retryRuleType",
    retryRuleAction: "retryRuleAction",
    objectStructureActions: "objectStructureActions",
    validatorsObjectProperties: "validatorsObjectProperties",
    proxyType: "proxyType",
    proxyProtocols: "proxyProtocols",
    zealCatalogs: "zealCatalogs",
    objectStructures: "objectStructures",
    publishRequestStatuses: "publishRequestStatuses",
    configCiTestTaskProgresses: "configCiTestTaskProgresses",
    httpMethodField: "httpMethodField",
    browserSourceTypes: "browserSourceTypes",
    userAgentEngines: "userAgentEngines",
    queueDriverTypes: "queueDriverTypes",
    metricTaskExecutorsField: "metricTaskExecutorsField",
    metricTaskTemplatesField: "metricTaskTemplatesField",
    credentialsTypes: "credentialsTypes",
    proxyTags: "proxyTags",
    branchTags: "branchTags",
    primaryKeyPlatformIDs: "primaryKeyPlatformIDs",
    searchUrlPatternTypes: "searchUrlPatternTypes",
    searchUrlPatternSortings: "searchUrlPatternSortings",
    primaryKeyItemTypes: "primaryKeyItemTypes",
    quotaTypes: "quotaTypes",
    platforms: "platforms",
    brightDataScrapingBrowserCredentials: "brightDataScrapingBrowserCredentials",
    oxylabsScrapingBrowserCredentials: "oxylabsScrapingBrowserCredentials",
    fulfillmentSystems: "fulfillmentSystems",
};

export default { moduleSlug };
